var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 72,
    viewBox: "0 0 50 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9695 71.1851L4.62148 65.5363L0.0869141 14.6769H49.9131L45.3738 65.5285L24.9695 71.1851Z",
    fill: "#264DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4877 62.2904L45.3666 18.8353H25V66.8613L41.4877 62.2904Z",
    fill: "#2965F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4822 37.6984L11.0412 43.9361H25V37.6984H10.4822ZM9.35876 25.0732L9.92576 31.3109H25V25.0732H9.35876ZM25 53.8984L24.9726 53.9056L18.0258 52.0298L17.5816 47.055H11.3199L12.1937 56.8492L24.9713 60.396L25 60.3882V53.8984Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8132 0.855408H19.3679V4.01478H14.9726V7.17416H19.3683V10.3333H11.8132V0.855408ZM20.8791 0.855408H28.4339V3.60267H24.0384V4.15209H28.4339V10.4708H20.8792V7.58588H25.2748V7.03646H20.8789V0.855408H20.8791ZM29.9451 0.855408H37.5V3.60267H33.1044V4.15209H37.5V10.4708H29.9451V7.58588H34.3406V7.03646H29.9453V0.855408H29.9451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4779 37.6984L40.6039 25.0732H24.9785V31.3109H33.7679L33.2003 37.6984H24.9785V43.9361H32.6595L31.9353 52.0259L24.9783 53.9037V60.3931L37.766 56.8492L37.8597 55.7952L39.3257 39.3734L39.4779 37.6984Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 70.5078,
    fill: "white",
    transform: "translate(0 0.855408)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.9c170c78175e8c840c8c76bd12e7b2ad.svg";
export { ForwardRef as ReactComponent };